<template>
    <div v-if="isLoading" class="loader2"></div>
    <div class="login-page">
        <div class="login-container">
            <div class="col-12">
                <img id="logo" src="../assets/img/logo_dark.svg"/>
            </div>
            <h1>Login Cutting Wizard</h1>
            <div class="form-group">
                <label for="username">Username</label>
                <input
                    id="username"
                    v-model="username"
                    type="text"
                    placeholder="Enter username"
                    required autocomplete="email"
                    autofocus
                />
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    type="password"
                    placeholder="Enter password"
                    required autocomplete="current-password"
                />
                </div>
            <div class="button-container">
                <RoundButton @submit="submitLogin" label="Login" gradient="true" />
            </div>
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
    </div>
</template>

<script>
/*eslint-disable*/
import { authService } from '@/services/authService'; // Make sure the path matches where you placed authService.js
import RoundButton from "@/components/RoundButton.vue"

export default {
    components: {
    RoundButton,
  },
  data() {
    // Check if it's development environment
    const isDevelopment = process.env.NODE_ENV === 'development';

    // Define the values
    const username = '';
    const password = '';

    return {
      username: username,
      password: password,
      errorMessage: '',
      isLoading: false,
    };
    },
    methods: {
      async submitLogin() {
        this.isLoading = true; // Start loading
        try {
            const user = await authService.login(this.username, this.password);
            console.log('Login successful', user);
            localStorage.setItem('userName', this.username)
            this.$emit('login-success', user);
        } catch (error) {
            console.error('Login failed', error);
            this.errorMessage = "Login failed. Please check your credentials or contact Bewo";
        } finally {
            this.isLoading = false; // Stop loading
        }
      },
    },
  };
</script>

<style lang="scss">
@import '../assets/scss/main';

.login-container {
  max-width: 500px;
  margin: auto;
  padding: 20px;
  border: 3px solid #000000;
  border-radius: 20px;
  background: white;
  position: relative; /* Ensure it's above the background */
  z-index: 1; /* Higher than the background */
}

.form-group {
    margin-bottom: 20px;
    margin-right: 0px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
}

.form-group input {
    width: 100%;
    padding: 1px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.login-button:hover {
    background-color: #45a049;
}

.error-message {
    color: red;
    text-align: center;
}

.button-container {
    align-items: center;
    margin-top: 20px; /* Add some top margin if needed */
}

.login-page {
  display: flex;
  justify-content: center;
  align-items: center; /* This will center the container vertically */
  height: 100vh; /* Use 100% of the viewport height */
  background: url("../assets/img/login_background.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}

.loader2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(to right, #f3f3f3 20%, #bbcd13 80%, #f3f3f3 80%);
  background-size: 200% 100%;
  animation: slide 2s linear infinite;
}

@keyframes slide {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
  </style>
